import BaseService from '../common/BaseService';
import { ENVIRONMENT } from '../common/endpoints';

export default class CommonService extends BaseService {
    constructor(props) {
        super(props);
    }

    getEnvironment() {
        return this.client.get(ENVIRONMENT).then(response => response.data);
    }
}